import React, { useState, useEffect, useCallback } from 'react'
import {
  bool, func, shape, string,
} from 'prop-types'
import { withI18n } from '@active/react-utils/i18n'

import EmailInputWithErrorContent from './EmailInputWithErrorContent'
import StaticEmailWithEditButton from './StaticEmailWithEditButton'
import './CheckEmail.scss'

const CheckEmail = withI18n(props => {
  const {
    changeAble,
    editAble,
    checkedResult,
    services,
    handleEmailChange,
    handleCheckAccount,
    changeExistAccount,
    getChangeAbleTrigger,
    checkEmailTrigger,

    name,
    value,
    onChange,
    hasError,
    tipContent,
    enableDomainCheck,
    ...rest
  } = props

  const [checkedResultState, setCheckedResultState] = useState(checkedResult)
  const [changeAbleState, setChangeAbleState] = useState(changeAble)
  const [inputValue, setInputValue] = useState(value)
  const [needDomainCheck, setNeedDomainCheck] = useState(!!enableDomainCheck)

  useEffect(() => { setInputValue(value) }, [value])

  const checkEmail = useCallback((newValue, callback, errorCallack) => {
    const { checkAccount } = services
    if (newValue !== checkedResultState.existAccount && newValue !== checkedResultState.newAccount) {
      setChangeAbleState(changeAble || changeAbleState || false)
      const api = !handleCheckAccount ? checkAccount : handleCheckAccount
      if (api) {
        api({
          params: { email: newValue, needDomainCheck },
          resolve: ({ status, nextStep, message }) => {
            let result = {}
            if (status === 'SUCCESS') {
              if (nextStep === 'login') {
                result = { existAccount: newValue }
              } else if (nextStep === 'detailInfo') {
                result = { newAccount: newValue }
              } else if (nextStep === 'badDomain') {
                result = { badDomain: newValue }
              }
              setCheckedResultState(result)
              typeof callback === 'function' && callback(result)
            } else {
              typeof errorCallack === 'function' && errorCallack(message)
            }
            setNeedDomainCheck(false)
          },
          reject: ({ message }) => {
            setNeedDomainCheck(false)
            typeof errorCallack === 'function' && errorCallack(message)
          },
        })
      } else {
        typeof callback === 'function' && callback(checkedResultState)
      }
    } else {
      typeof callback === 'function' && callback(checkedResultState)
    }
  }, [changeAble, changeAbleState, checkedResultState, handleCheckAccount, services])

  useEffect(() => {
    // Inject getChangeAble function to trigger
    if (typeof getChangeAbleTrigger === 'function') {
      const getChangeAble = () => changeAbleState
      getChangeAbleTrigger(getChangeAble)
    }

    if (typeof checkEmailTrigger === 'function') {
      checkEmailTrigger(checkEmail)
    }
  }, [changeAbleState, checkEmail, checkEmailTrigger, getChangeAbleTrigger])

  const handleChange = useCallback(event => {
    const newValue = event.target.value
    setInputValue(newValue)
    setCheckedResultState({})
    onChange && onChange(newValue)
    handleEmailChange && handleEmailChange(newValue)
  }, [handleEmailChange, onChange])

  if (changeAbleState) {
    return (
      <EmailInputWithErrorContent
        name={name}
        hasError={hasError}
        inputValue={inputValue}
        handleChange={handleChange}
        changeExistAccount={changeExistAccount}
        checkedResultState={checkedResultState}
        tipContent={tipContent}
        remoteCheck={false}
        {...rest}
        autoComplete="email"
      />
    )
  }

  return <StaticEmailWithEditButton editAble={editAble} handleEdit={() => setChangeAbleState(true)} />
})

CheckEmail.propTypes = {
  services: shape({
    checkAccount: func.isRequired,
  }),
  changeAble: bool,
  editAble: bool,
  checkedResult: shape({
    newAccount: string,
  }),
  changeExistAccount: func,
  handleEmailChange: func,
  // Use to override services.checkAccount
  handleCheckAccount: func,
  getChangeAbleTrigger: func, // Use to get changeAble from state
  checkEmailTrigger: func,
}

CheckEmail.defaultProps = {
  services: { checkAccount: () => { } },
  changeAble: false,
  editAble: false,
  checkedResult: {},
  changeExistAccount: undefined,
  handleEmailChange: undefined,
  handleCheckAccount: undefined,
  getChangeAbleTrigger: undefined,
  checkEmailTrigger: undefined,
}

export default CheckEmail
